import { render, staticRenderFns } from "./reviewManagement.vue?vue&type=template&id=f6956ac0&scoped=true"
import script from "./reviewManagement.vue?vue&type=script&lang=js"
export * from "./reviewManagement.vue?vue&type=script&lang=js"
import style0 from "./reviewManagement.vue?vue&type=style&index=0&id=f6956ac0&prod&lang=less&scoped=true"
import style1 from "./reviewManagement.vue?vue&type=style&index=1&id=f6956ac0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6956ac0",
  null
  
)

export default component.exports